import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AlertService {

  constructor(private alertController: AlertController) { }

  async showInfoMessage(msg = '') {
    const alert = await this.alertController.create({
      header: 'Info',
      message: msg,
      backdropDismiss: false,
      buttons: ['OK']
    });
    await alert.present();
  }

  async showErrorMessage(msg = '') {
    const alert = await this.alertController.create({
      header: 'Error',
      message: msg,
      backdropDismiss: false,
      buttons: ['OK']
    });
    await alert.present();
  }
}
